import { ReactNode, useEffect, useRef } from 'react';

export default function DiagramMotion({ children }: { children: ReactNode }) {
  const host = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!host.current || typeof IntersectionObserver === 'undefined') return;
    const visibility = new Map<Element, boolean>();
    const update = () => visibility.forEach((visible, element) => {
      (element as HTMLElement).style.setProperty('--diagram-play-state', visible && !document.hidden ? 'running' : 'paused');
    });
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => visibility.set(entry.target, entry.isIntersecting));
      update();
    });
    host.current.querySelectorAll('.delivery-diagram, .service-system, .service-inline-diagram, .service-design-figure, .training-lab, .value-diagram, .case-flow').forEach(element => observer.observe(element));
    document.addEventListener('visibilitychange', update);
    return () => { observer.disconnect(); document.removeEventListener('visibilitychange', update); };
  }, [children]);
  return <div ref={host} className="diagram-motion-scope">{children}</div>;
}
